//import logo from './logo.svg';
import logo from './logo.png';

export const settings = {
    "title": "Etis CRM",
    "apiUrl": "https://api.crm.etissrl.it/api",
    "ckdPath": "https://api.crm.etissrl.it/",
    "tinyKey": "uxd8thxx2a96p0tne20wyfcdx7zvpyprm38j5q5w9qqauy2p",
    "googleMapKey": "AIzaSyDwVSRwXezXuTLG8-VAe1KfNKo7zLPlYJQ",
    "config": {
        "limit": 50,
        "sortingField": 'id',
        "sortingOrder": 'desc'
    },
    "configEntity": {
        "customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_offer": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_customer_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "gyv_supplier_order": {
            "limit": 20,
            "sortingField": 'id',
            "sortingOrder": 'desc'
        },
        "customer": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "supplier": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        },
        "sales_agent": {
            "limit": 50,
            "sortingField": 'name',
            "sortingOrder": 'asc'
        }
    },
    "theme": {
        "siderbarIconColor": 'rgba(233,236,239,.5)'
    },
    "logo": logo,
    "data_print": {
        "name": 'Etis srl',
        "address": 'Via Casa Rossa, 10 - 40010 Bentivoglio (BO) IT',
        "phone": 'Tel: 051 761356',
        "fax": 'PEC: info@pec.etissrl.it',
        "email": 'Email: info@etissrl.it',
        "iva": 'P.IVA: IT02595081205',
        "cf": '',
        "website": 'Sito Web: www.mascagnisoluzionecasa.com'
    },
    "stampe" : {
       "arredatore": true, 
       "sconto": true, 
       "listino": true, 
       "condVendita": true, 
       "firmaVenditore": true
    },
    "dati_pagamento": {
        "iban": "IT66J0303237070010000001968",
        "banca": "Banca Credito Emiliano Spa",
        "intestatario": "Etis Srl",
    },
    "iva_label": 'inclusa',
    "iva_esclusa": false,
    "sconti": true,
    "fatturazione": true,
    "usingCache": false
}